<div class="h-full flex flex-col w-full">
	@if (form$ | async) {
		<div class="flex justify-between mb-2 gap-2 items-end">
			<div class="flex justify-end mb-2 gap-2">
				<app-button
					btn="secondary"
					size="small"
					[icon]="ICON.PRINT"
					(click)="print()"
				>
					Print
				</app-button>
				<app-button
					btn="secondary"
					size="small"
					[icon]="ICON.PDF"
					(click)="download()"
				>
					Download
				</app-button>
			</div>
		</div>
		<app-matter-form-instance-viewer
			#pdfViewerInstanceViewer
			[form]="form$ | async"
			class="w-full h-full"
		/>
	} @else if (loading_()) {
		<div class="flex items-center justify-center w-full h-full">Loading...</div>
	} @else if (error_()) {
		<div class="flex flex-col items-center justify-center w-full h-full">
			<p class="mt-2 text-lg font-semibold text-gray-600">
				We're sorry — this form is currently unavailable. Please contact support
				for assistance.
			</p>
		</div>
	}
</div>
